import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export const GET_DOCUMENTS_BY_SOURCE = gql`
	query GetDocumentsBySource(
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: DocumentListFilterInput!
		$source: Int!
		$status: DocumentStatus!
		$order: [DocumentListSortInput!]
	) {
		documentList(
			before: $before
			after: $after
			first: $first
			last: $last
			where:
			{and : [
				{source: {id: {eq:$source}}}
				{status: {eq:$status}}
				$where
				]}
				
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				category
				created
				from
				to
				description
				customer
				customerId
				source{
					id
					code
					description
				}
				comment,
				lock {
					userName,
					timeStamp
				}
			}
		}
	}
`;
